var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      staticClass: "header-logo",
      attrs: {
        width: "136",
        height: "24",
        viewBox: "0 0 136 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M132.079 7.37947H128.964L128.963 19.1402H126.262L126.263 7.37947L123.146 7.37849V5.00577H132.08L132.079 7.37947ZM116.633 10.4249C117.713 10.8068 118.73 11.1878 119.436 11.8468C120.06 12.4187 120.619 13.3725 120.618 14.8139C120.617 17.5686 118.663 19.4536 115.796 19.4516C113.241 19.4507 111.747 17.8604 111.02 16.7793L112.787 15.0636C113.452 16.4414 114.717 16.9506 115.694 16.9506C116.92 16.9526 117.834 16.1898 117.835 15.0039C117.835 14.4947 117.669 14.0912 117.297 13.7309C116.777 13.2432 115.946 12.9671 115.157 12.6909C114.43 12.4363 113.557 12.0975 112.851 11.461C112.395 11.0585 111.752 10.2732 111.752 8.8317C111.753 6.75569 113.125 4.67969 116.2 4.68066C117.072 4.68164 118.713 4.85301 120.125 6.33657L118.711 8.22163C117.902 7.11899 116.946 7.01323 116.448 7.01225C114.994 7.01128 114.535 7.9445 114.535 8.66523C114.535 9.00307 114.639 9.32132 114.971 9.61902C115.303 9.93629 115.759 10.1057 116.633 10.4249ZM104.474 19.1334L104.476 4.99892H107.176L107.175 19.1334H104.474ZM93.6465 19.1471L87.8271 5.01263H90.7772L94.4753 14.5064L98.1725 5.01165H101.123L95.2667 19.1471H93.6465ZM78.7837 19.4526C77.0596 19.4517 75.274 19.0903 73.7576 17.5411C73.2797 17.0554 71.7027 15.2732 71.7047 12.0955C71.7066 9.36049 72.9114 7.68696 73.7432 6.83991C74.7826 5.7598 76.5278 4.67969 79.2077 4.68164C80.2462 4.68262 81.3472 4.85301 82.4059 5.42587C83.3001 5.89199 84.2751 6.741 85.0021 8.01207L82.6539 9.30468C82.177 8.34991 81.4703 7.86224 81.0347 7.6282C80.452 7.33149 79.725 7.18264 79.0808 7.18264C77.9808 7.18166 76.7336 7.58414 75.8807 8.43119C75.0922 9.21458 74.4884 10.5699 74.4874 12.1602C74.4865 14.0452 75.2759 15.1704 75.8567 15.7423C76.4798 16.3572 77.4567 16.9516 78.9308 16.9516C79.8452 16.9526 80.8837 16.699 81.653 16.1056C82.1924 15.6825 82.7337 14.9628 82.9626 13.9453L79.3894 13.9434L79.3914 11.5687L85.7473 11.5736V11.742C85.7473 12.6968 85.6213 15.6629 83.7078 17.5911C82.2741 19.0521 80.5087 19.4536 78.7837 19.4526ZM66.4853 19.1324L58.6563 10.1282L58.6573 19.1344L55.9572 19.1334L55.9582 4.99892H57.8284L65.6555 13.9806V4.99696H68.3565L68.3546 19.1334L66.4853 19.1324ZM48.6917 4.99892H51.3917V19.1334H48.6917V4.99892ZM36.8809 4.98815L39.5819 4.98717L39.5876 16.5247L44.7435 16.5266V19.1236H36.8886L36.8809 4.98815Z",
          fill: "#2C3143",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M12.6592 3.48828V6.52699L21.7975 11.9192L12.6592 17.3412V20.3501L26.8905 11.9192L12.6592 3.48828Z",
          fill: "#2C3143",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M2.56105 16.2687V5.00764L0 3.48828V20.797L12.6597 13.2896V10.2807L2.56105 16.2687Z",
          fill: "#2C3143",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }